import routes from '@/routes/routes';
import { formatDateTime } from '@/utils/datetime';
import Link from 'next/link';
import { BlogPostDto } from '../blog.dto';

export type BlogRecentPostItemParams = { post: BlogPostDto };
export const BlogRecentPostItem = ({ post }: BlogRecentPostItemParams) => {
  return (
    <div className="flex flex-col gap-y-3 h-full">
      <Link href={routes.blogPost({ title: post.title, id: post.id })}>
        <a className="h-full">
          <>
            <div className="relative h-full">
              <img
                alt={post.headerImage?.altText || 'post image'}
                src={post.headerImage?.image?.url}
                className="w-full rounded-lg object-cover h-full min-h-[200px]"
              />
              {post.category && (
                <span className="absolute z-[1] left-0 top-2 p-2 text-sm bg-secondary-light text-white rounded-r-lg">
                  {post.category?.name}
                </span>
              )}
              <div className="absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-black to-transparent rounded-md opacity-" />
              <div className="absolute z-[1] flex flex-col bottom-4 left-4 right-0 gap-y-3">
                <h2 className="font-bold text-lg text-white">{post.title}</h2>
                <div className="flex flex-row gap-x-10 text-sm text-white">
                  <span>{post.author?.name}</span>
                  <span className="truncate">{formatDateTime(post.createdAt)}</span>
                </div>
              </div>
            </div>
          </>
        </a>
      </Link>
    </div>
  );
};
